<template>
  <b-container>
    <div>
      <b-navbar
        toggleable="lg"
        variant="faded"
        type="light"
        class="marketplace-navbar"
      >
        <!-- LEFT -->
        <b-navbar-nav>
          <b-nav-item href="#" class="padding-adjustment">
            <b-button class="hidden-focus" style="padding: 0; border: 0; background-color: white; border-color: white;" size="sm" v-b-toggle.sidebar-menu>
              <b-icon-grid3x3-gap-fill style="color: #838383;"></b-icon-grid3x3-gap-fill>
            </b-button>
          </b-nav-item>

          <b-navbar-brand href="#"
        ><img
          src="../../../src/assets/images/dropsmart-logo.png"
          alt="Dropsmart Logo"
          /></b-navbar-brand>

          <!-- MENU ITEMS -->
          <b-collapse id="nav-collapse" is-nav>
            <div v-for="(item, index) in menuItems" :key="index" class="menu-item-container" 
              @click="isActive = index; goToUrl(item.route);"
              :class="index === isActive && index != 0 ? 'active' : '' ">
              <b-nav-item>
                {{item.display}}
              </b-nav-item>
            </div>

          </b-collapse>
        </b-navbar-nav>
        
         <!-- RIGHT/AVATAR ICON AND LOGOUT-->
        <b-navbar-nav>
          <b-nav-item 
            href="#" 
            class="user-icon-adjustment" 
            @click="$emit('navigate', 'CentreMyAccount'); itemDisable(null); goToUrl('CentreMyAccount')"
            >
            <b-avatar class="user-avatar-icon" variant="light" :src="avatarUrl" size="2.1rem" style="color: #838383;"></b-avatar>
            <!-- <b-icon-person-circle style="color: #838383;"></b-icon-person-circle> -->
          </b-nav-item>

          <!-- LOGOUT ICON -->
          <b-nav-item 
            v-b-tooltip.hover.bottom.v-dark
            title="Logout"
            href="#" 
            class="logout-adjustment" 
            @click="logoff()"
            >
            <b-avatar class="bg-white" size="2.1rem"><b-icon-box-arrow-right style="color: #838383;"></b-icon-box-arrow-right></b-avatar>
          </b-nav-item>
        </b-navbar-nav>

      </b-navbar>
    </div>
  </b-container>
</template>

<script>
import { FRONTEND_URL } from "@/config";

export default {
  name: "DropsmartCenterHeaderNavBar",
  props: ["menuItems", "customerInfo"],
  mounted() {
    //check route first
    let index = this.menuItems.map(object => object).indexOf(this.$route.name);
    index === -1 ? this.isActive = null : this.isActive = index;
    if(this.$route.name === 'DropsmartCentre' || this.$route.name === 'Perks') {
      this.isActive = 3; //for now, while the home is the Perks section
    }

    this.$root.$on("item-selected", (index) => {
      if(index === 0) {
        this.isActive = 3;
      } else {
        this.isActive = index;
      }
    });
    this.$root.$on("item-disable", (value) => {
      this.isActive = value;
    });
  },
  // updated() {
  //   if(this.isActive === 1) {
  //     this.isActive = null;
  //   }
  // },
  data() {
    return {
      isActive: 3, //to activate first the menu Perks otherwise is better to assign it to null
    };
  },
  computed: {
    // avatarUrl() {
    //   if (!this.customerInfo || !this.customerInfo.user.avatarUrl) {
    //     return null;
    //   }
    //   return FRONTEND_URL.AvatarURL + this.customerInfo.user.avatarImage;
    // },
    avatarUrl() {
      if (this.customerInfo) {
          if (this.customerInfo.user.avatarImage) {
            return FRONTEND_URL.AvatarURL + this.customerInfo.user.avatarImage;
          }
      }
      return null;
      // return 'https://app.dropsmarteo.com/api/containers/medium_avatar/download/c777b9171099e95d64b7c955cef696a4.jpg';
    },
  },
  methods: {
    itemDisable(value) {
      this.isActive = value;
    },
    goToUrl(sectionName) {
      if (sectionName === 'App') {
        window.open('https://app.dropsmarteo.com/', '_blank', 'noreferrer');
      } else {        
        // If it is a FREE user, do not give access to Academy, Premium, or LiveQA pages
        if (  !this.customerInfo.user.paid
            && (sectionName == 'Academy' || sectionName == 'Premium' || sectionName == 'LiveQA') ) {
              sectionName = 'Perks';
        }
        this.$emit('navigate', sectionName);
        this.$router.push({
          name: sectionName,
        }).catch(()=>{});
      }
    },
    logoff: function() {
      sessionStorage.setItem("customerInfo", null);
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0;
}

.form-control:focus {
  border-color: none;
  box-shadow: none;
}

button.hidden-focus:focus {
  border-color: none;
  box-shadow: none;
}

.marketplace-navbar {
  justify-content: space-between; //in case to also show the search bar and the other icons
  //justify-content: center; //if just the brand is up there
  align-items: end;
  padding-right: 0;
  padding-left: 0;

  ul.navbar-nav {
  align-items: end;

    a.nav-link {
    padding: 0 0;
    //margin: 0 1rem;
    }

    a.navbar-brand {
    //padding: 0;
    margin: 0 0 0 1rem;
    max-width: 180px;

      img {
        vertical-align: bottom;
        max-width: 90%;
        //max-height: 31px; maintain it if all the navbar is shown
      }
    }

    .menu-item-container {
      border: none;
      margin: 0 1rem;

      a.nav-link {
        padding: 0;
      }

      &:hover {
        border-bottom: 2px solid #838383;
      }

    }

    .menu-item-container.active {
      border-bottom: 2px solid #838383;
    }

    a.nav-link:focus {
      color: #838383;
    }

  }
}



li {
  list-style: none;
  padding: 0;
  margin: 0;
  a {
    color: black;
  }
}

li.padding-adjustment:first-child {
  margin: 0 1rem 0 0;
}

li.padding-adjustment {
  margin: 0 1rem;
}

li.logout-adjustment {
  margin-left: 1rem;
}

.search-area-container {
  width: 100%;
}

.search-input {
  background-color: transparent;
  border: none;
}

.search-area {
  margin: 0 1.2rem;
  border-radius: 3rem;
  background-color: #ffffff;
  border: solid 1px black;

  .search-icon-box {
    background-color: transparent;
    border: none;

    .input-group-text {
      background-color: transparent;
      border: none;
    }
  }
}

a.nav-link {
  padding: 0;
  //height: 31px;

  svg {
    height: 31px;
    width: 25px;
  }
}

li:last-child {
  a.nav-link {
    //padding-right: 0;
  }
}

li.user-icon-adjustment {
  margin: 0;
}

@media screen and (max-width: 991px) {
  .navbar-nav {
    flex-direction: row;
  }
}

</style>
